import classNames from "classnames";
import React from "react";
import { IGalleryElement } from "../../app/models/content";
import ProtectedImage from "../common/ProtectedImage";
import ExistingNoteIcon from "../icons/ExistingNoteIcon";

interface IParams {
  item: IGalleryElement;
  isSelected: boolean;
}
const timeStamp = new Date().getMilliseconds();
const CustomThumbnail: React.FC<IParams> = ({ item, isSelected }) => {
  return (
    <>
      <div
        className={classNames(
          isSelected ? "image-gallery-selected-thumbnail" : "",
          "position-relative"
        )}
      >
        <ProtectedImage
        url={item.thumbnail.includes("?") ? `${item.thumbnail}&ts=${timeStamp}` : `${item.thumbnail}?ts=${timeStamp}`}
          // url={`${item.thumbnail}`}
          className={"image-gallery-image image-gallery-div"}
        />
        {item.hasNote && <ExistingNoteIcon />}
        <div className="image-gallery-text-container">
          <h6 className="customh6">
            {item.index}/{item.totalNumber}
          </h6>
        </div>
      </div>
    </>
  );
};

export default CustomThumbnail;
